import { React, Fragment } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/LtsBottomSheet.css';
import LiveTrainBetweenTwoStations from './LiveTrainBetweenTwoStations';

const LtsBottomSheet = ({ onToggleBottomSheet }) => {
  return (
    <Fragment>
      <div className="backdrop" onClick={onToggleBottomSheet} />
      <div className="modal">
        <div className="content">
          <LiveTrainBetweenTwoStations />
        </div>
      </div>
    </Fragment>
  );
};

LtsBottomSheet.propTypes = {
  onToggleBottomSheet: PropTypes.func.isRequired
};

export default LtsBottomSheet;
